import { render, staticRenderFns } from "./PrintChat.vue?vue&type=template&id=efddff30&scoped=true&"
import script from "./PrintChat.vue?vue&type=script&lang=js&"
export * from "./PrintChat.vue?vue&type=script&lang=js&"
import style0 from "./PrintChat.vue?vue&type=style&index=0&id=efddff30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efddff30",
  null
  
)

export default component.exports